import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {PoolStatistics, PoolStatisticsMode} from "../payload-types/pool-statistics";

/**
 * API interface for the POOL-tab order-pool statistics (#19113,
 * GET {@link RevaApi.PATH_VALUATIONS_POOL_STATISTICS}): the current age distribution of the
 * unassigned valuations the requesting user could take over. The `mode` query param selects the
 * time unit of the threshold tiles and the chart buckets (WEEKS / MONTHS / DYNAMIC); the pool is
 * scoped to the same filter as the POOL-tab list.
 */
export class PoolStatisticsApiInterface extends SimpleApiInterface<PoolStatistics> {
    constructor(private readonly mode: PoolStatisticsMode) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS_POOL_STATISTICS], {mode: this.mode});
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<PoolStatistics> {
        return executor.fetchGET(url, credentials);
    }
}
